/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

// Version comes from app/package.json at RUNTIME so the dev badge updates over
// HMR the moment the pre-commit hook bumps it — a build-time `define` left dev
// showing a stale number until the dev server restarted. `__APP_VERSION__` below
// is the FALLBACK, not the source. SHA + build time stay build-time injected
// (they can only be known at build).
/* global __APP_VERSION__, __GIT_SHA__, __BUILD_TIME__ */
import pkg from "../../../package.json";

export const VERSION = pkg?.version
  || (typeof __APP_VERSION__ !== "undefined" ? __APP_VERSION__ : "0.0.0");
export const GIT_SHA = typeof __GIT_SHA__ !== "undefined" ? __GIT_SHA__ : "dev";
export const BUILD_TIME = typeof __BUILD_TIME__ !== "undefined" ? __BUILD_TIME__ : "";

// e.g. "v0.1.1 · a034404"
export const VERSION_LABEL = `v${VERSION} · ${GIT_SHA}`;
